import store from "@frameworks/web/redux/store/index";
import { CLIENTDETAILS, CLIENTDETAILS_ERROR, CLIENTDETAILS_HIDE_ERROR, CLIENTDETAILS_START_LOADER, CLIENTDETAILS_STOP_LOADER } from "../interface/IClientDetails";
class ClientDetailsGroupsActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getClientDetailsData(data) {
        this.dispatch({
            type: CLIENTDETAILS,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: CLIENTDETAILS_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: CLIENTDETAILS_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: CLIENTDETAILS_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: CLIENTDETAILS_STOP_LOADER,
        });
    }
}
export default ClientDetailsGroupsActions;
